import React, { useContext, useState } from "react";
import {
  Container,
  Nav,
  NavItem,
  AuthButtons,
  MenuIcon,
  SideMenu,
  CloseIcon,
  Overlay,
  SideMenuContainer,
  SideMenuItem,
  SecondaryButton,
  HeaderLogo,
} from "./Header.styles";
import {
  Menu,
  X,
  Home,
  Info,
  Mail,
  Bug,
  MessageSquareIcon,
  Users,
  Briefcase,
  ClipboardList,
  Star,
  FolderKanban,
  ChevronDown,
  ChevronUp,
  Settings,
  User,
} from "lucide-react";
import AuthModal from "../modal/AuthModal";
import { UserContext } from "../../context/UserContext";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [myMenuOpen, setMyMenuOpen] = useState(false);
  const { user } = useContext(UserContext);
  const navigate = useNavigate();
  const location = useLocation();
  const handleMouseLeave = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    const related = e.relatedTarget as HTMLElement | null;
    if (!related || !e.currentTarget.contains(related)) {
      setDropdownOpen(false);
    }
  };
  return (
    <>
      <Container>
        <HeaderLogo src={require("../../assets/header_logo.png")} alt="Logo" />

        <Nav>
          <NavItem href="/" active={location.pathname === "/"}>
            Home
          </NavItem>

          {user ? (
            <>
              <NavItem
                href="/code-issues"
                active={location.pathname === "/code-issues"}
              >
                Code Issues
              </NavItem>
              <NavItem
                href="/members"
                active={location.pathname === "/members"}
              >
                Developers
              </NavItem>
              <NavItem
                href="/referral-jobs"
                active={location.pathname === "/referral-jobs"}
              >
                Referral Jobs
              </NavItem>
              <NavItem
                href="/freelance-projects"
                active={location.pathname === "/freelance-projects"}
              >
                Freelance Projects
              </NavItem>

              {/* MY DASHBOARD DROPDOWN */}
              {/* MY DASHBOARD DROPDOWN */}
              <DropdownWrapper>
                <DropdownToggle
                  onClick={() => setDropdownOpen((prev) => !prev)}
                  active={
                    location.pathname.startsWith("/my-") ||
                    location.pathname === "/chats" ||
                    location.pathname === "/settings"
                  }
                >
                  My Dashboard{" "}
                  {dropdownOpen ? (
                    <ChevronUp size={16} />
                  ) : (
                    <ChevronDown size={16} />
                  )}
                </DropdownToggle>

                {dropdownOpen && (
                  <DropdownMenu>
                    <DropdownHeader>
                      <h4>My Dashboard</h4>
                      <CloseDropBtn onClick={() => setDropdownOpen(false)}>
                        <X size={16} />
                      </CloseDropBtn>
                    </DropdownHeader>

                    <DropdownItem
                      onClick={() => {
                        navigate("/my-projects");
                        setDropdownOpen(false);
                      }}
                      active={location.pathname === "/my-projects"}
                    >
                      <FolderKanban size={16} /> My Projects
                    </DropdownItem>

                    <DropdownItem
                      onClick={() => {
                        navigate("/my-referral-jobs");
                        setDropdownOpen(false);
                      }}
                      active={location.pathname === "/my-referral-jobs"}
                    >
                      <Star size={16} /> My Referral Jobs
                    </DropdownItem>

                    <DropdownItem
                      onClick={() => {
                        navigate("/job-applications");
                        setDropdownOpen(false);
                      }}
                      active={location.pathname === "/job-applications"}
                    >
                      <ClipboardList size={16} /> Job Applications
                    </DropdownItem>

                    <DropdownItem
                      onClick={() => {
                        navigate("/chats");
                        setDropdownOpen(false);
                      }}
                      active={location.pathname === "/chats"}
                    >
                      <MessageSquareIcon size={16} /> Group Chats
                    </DropdownItem>

                    <DropdownItem
                      onClick={() => {
                        navigate("/my-chats");
                        setDropdownOpen(false);
                      }}
                      active={location.pathname === "/my-chats"}
                    >
                      <MessageSquareIcon size={16} /> My Chats
                    </DropdownItem>
                  </DropdownMenu>
                )}
              </DropdownWrapper>
            </>
          ) : (
            <>
              <NavItem href="/about" active={location.pathname === "/about"}>
                About
              </NavItem>
              <NavItem
                href="/contact-us"
                active={location.pathname === "/contact-us"}
              >
                Contact
              </NavItem>
            </>
          )}
        </Nav>

        <AuthButtons>
          {!user ? (
            <SecondaryButton onClick={() => setModalOpen(true)}>
              Login / Sign Up
            </SecondaryButton>
          ) : (
            <SecondaryButton onClick={() => navigate("/profile/" + user.id)}>
              My Account
            </SecondaryButton>
          )}
        </AuthButtons>

        {!menuOpen && (
          <MenuIcon onClick={() => setMenuOpen(true)}>
            <Menu size={28} />
          </MenuIcon>
        )}

        <AuthModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
      </Container>

      {/* -------------- MOBILE SIDEMENU -------------- */}
      {menuOpen && (
        <>
          <SideMenu>
            <CloseIcon onClick={() => setMenuOpen(false)}>
              <X size={28} />
            </CloseIcon>

            <SideMenuContainer>
              <SideMenuItem
                active={location.pathname === "/"}
                onClick={() => {
                  navigate("/");
                  setMenuOpen(false);
                }}
              >
                <Home size={20} />
                Home
              </SideMenuItem>

              {user && (
                <>
                  <SideMenuItem
                    active={location.pathname === "/code-issues"}
                    onClick={() => {
                      navigate("/code-issues");
                      setMenuOpen(false);
                    }}
                  >
                    <Bug size={20} />
                    Code Issues
                  </SideMenuItem>
                  <SideMenuItem
                    active={location.pathname === "/members"}
                    onClick={() => {
                      navigate("/members");
                      setMenuOpen(false);
                    }}
                  >
                    <Users size={20} />
                    Members
                  </SideMenuItem>
                  <SideMenuItem
                    active={location.pathname === "/referral-jobs"}
                    onClick={() => {
                      navigate("/referral-jobs");
                      setMenuOpen(false);
                    }}
                  >
                    <Briefcase size={20} />
                    Referral Jobs
                  </SideMenuItem>

                  <SideMenuItem
                    active={location.pathname === "/freelance-projects"}
                    onClick={() => {
                      navigate("/freelance-projects");
                      setMenuOpen(false);
                    }}
                  >
                    <FolderKanban size={20} />
                    Freelance Projects
                  </SideMenuItem>
                  <SideMenuItem
                    active={location.pathname === "/profile/" + user.id}
                    onClick={() => {
                      navigate("/profile/" + user.id);
                      setMenuOpen(false);
                    }}
                  >
                    <User size={20} />
                    My Profile
                  </SideMenuItem>
                  <SideMenuItem
                    active={location.pathname === "/about"}
                    onClick={() => {
                      navigate("/about");
                      setMenuOpen(false);
                    }}
                  >
                    <Info size={20} />
                    About
                  </SideMenuItem>
                  <SideMenuItem
                    active={location.pathname === "/contact-us"}
                    onClick={() => {
                      navigate("/contact-us");
                      setMenuOpen(false);
                    }}
                  >
                    <Mail size={20} />
                    Contact
                  </SideMenuItem>
                  <SectionTitle
                    onClick={() => setMyMenuOpen(!myMenuOpen)}
                    style={{ cursor: "pointer" }}
                  >
                    My Dashboard{" "}
                    {myMenuOpen ? (
                      <ChevronUp size={16} />
                    ) : (
                      <ChevronDown size={16} />
                    )}
                  </SectionTitle>

                  {myMenuOpen && (
                    <MySection>
                      <SideMenuItem
                        active={location.pathname === "/my-projects"}
                        onClick={() => {
                          navigate("/my-projects");
                          setMenuOpen(false);
                        }}
                      >
                        <FolderKanban size={18} />
                        My Projects
                      </SideMenuItem>

                      <SideMenuItem
                        active={location.pathname === "/my-referral-jobs"}
                        onClick={() => {
                          navigate("/my-referral-jobs");
                          setMenuOpen(false);
                        }}
                      >
                        <Star size={18} />
                        My Referral Jobs
                      </SideMenuItem>

                      <SideMenuItem
                        active={location.pathname === "/job-applications"}
                        onClick={() => {
                          navigate("/job-applications");
                          setMenuOpen(false);
                        }}
                      >
                        <ClipboardList size={18} />
                        Job Applications
                      </SideMenuItem>

                      <SideMenuItem
                        active={location.pathname === "/chats"}
                        onClick={() => {
                          navigate("/chats");
                          setMenuOpen(false);
                        }}
                      >
                        <MessageSquareIcon size={18} />
                        Group Chats
                      </SideMenuItem>
                      <SideMenuItem
                        active={location.pathname === "/my-chats"}
                        onClick={() => {
                          navigate("/my-chats");
                          setMenuOpen(false);
                        }}
                      >
                        <MessageSquareIcon size={18} />
                        My Chats
                      </SideMenuItem>

                      {/* <SideMenuItem
                        active={location.pathname === "/settings"}
                        onClick={() => {
                          navigate("/settings");
                          setMenuOpen(false);
                        }}
                      >
                        <Settings size={18} />
                        Settings
                      </SideMenuItem> */}
                    </MySection>
                  )}
                </>
              )}
              {!user && (
                <>
                  <SideMenuItem
                    active={location.pathname === "/about"}
                    onClick={() => {
                      navigate("/about");
                      setMenuOpen(false);
                    }}
                  >
                    <Info size={20} />
                    About
                  </SideMenuItem>
                  <SideMenuItem
                    active={location.pathname === "/contact-us"}
                    onClick={() => {
                      navigate("/contact-us");
                      setMenuOpen(false);
                    }}
                  >
                    <Mail size={20} />
                    Contact
                  </SideMenuItem>
                  <SecondaryButton onClick={() => setModalOpen(true)}>
                    Login / Sign Up
                  </SecondaryButton>
                </>
              )}
            </SideMenuContainer>
          </SideMenu>
          <Overlay />
        </>
      )}
    </>
  );
};

export default Header;

/* ---------- Extra Styles ---------- */
const DropdownHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  border-bottom: 1px solid rgba(155, 92, 255, 0.3);

  h4 {
    font-size: 0.95rem;
    color: #c59fff;
    font-weight: 600;
    margin: 0;
  }
`;

const CloseDropBtn = styled.button`
  background: transparent;
  border: none;
  color: #aaa;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    color: #fff;
    transform: rotate(90deg);
  }
`;

const SectionTitle = styled.div`
  color: #c59fff;
  font-weight: 600;
  margin: 16px 0 6px 12px;
  display: flex;
  align-items: center;
  gap: 6px;
`;

const MySection = styled.div`
  margin-left: 8px;
  border-left: 2px solid rgba(155, 92, 255, 0.3);
  padding-left: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const DropdownWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 12px; /* ✅ same horizontal spacing as NavItem */
  cursor: pointer;
`;

const DropdownToggle = styled.div<{ active?: boolean }>`
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${({ active }) => (active ? "#c59fff" : "#e0e0e0")};
  font-weight: 600;
  height: 100%;
  transition: color 0.3s ease;
  border-bottom: ${({ active }) =>
    active ? "2px solid #c59fff" : "2px solid transparent"};

  &:hover {
    color: #c59fff;
  }

  svg {
    transition: transform 0.3s ease;
    transform: ${({ active }) => (active ? "rotate(180deg)" : "rotate(0)")};
  }
`;

const DropdownMenu = styled.div`
  position: absolute;
  top: 100%; /* ✅ directly below toggle */
  left: 0;
  background: #0f0b18;
  border: 1px solid rgba(155, 92, 255, 0.3);
  border-radius: 10px;
  box-shadow: 0 0 15px rgba(155, 92, 255, 0.15);
  min-width: 220px;
  z-index: 1000;
  padding: 8px 0;
  margin-top: 4px; /* small spacing, but no visible gap */
`;

const DropdownItem = styled.div<{ active?: boolean }>`
  padding: 10px 16px;
  color: ${({ active }) => (active ? "#fff" : "#ccc")};
  background: ${({ active }) =>
    active ? "rgba(155, 92, 255, 0.15)" : "transparent"};
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 0.95rem;
  transition: 0.3s;

  &:hover {
    background: rgba(155, 92, 255, 0.1);
    color: #fff;
  }
`;
